export const adminsList = ['6Lpkv0kjBnSoZoZNW1EreDm2yFW2'];
